import React, { useRef } from 'react';
import { Grid, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

export const formattedItem = (type, option) => {
  if (!option) return ''
  console.log('Format our item', type)
  if (type === 'jobSite') {
    return `${option?.communityName ? ` ${option.communityName} - ` : ''}${option?.name || ''}${option?.address ? ` ${option.address}` : ''}${option?.buildingNumber ? ` Bldge #${option.buildingNumber}` : ''}${option?.city ? ` ${option.city},` : ''}${option?.city ? ` ${option.city}` : ''}`
  }
  if (type === 'vehicle') {
    return `${option?.name || ''} (${option?.year ? `${option.year}` : ''}${option?.manufacturer ? ` ${option.manufacturer}` : ''}${option?.model ? ` ${option.model}` : ''})`
  }
  if (type === 'equipment') {
    return `${option?.name || ''} (${option?.year ? `${option.year}` : ''}${option?.manufacturer ? ` ${option.manufacturer}` : ''}${option?.model ? ` ${option.model}` : ''})`
  }
}




const KeyInputs = ({ state, setState, props, equipRef }) => {
  const inputRef = useRef({});

  // Handle selection of vehicle
  const handleVehicleSelect = (event, value) => {
    const keyName = `Key for ${formattedItem('equipment', value)}`
    if (inputRef.current) {
      inputRef.current.vehicle = value;
    }
    if (equipRef && equipRef.current) {
      equipRef.current.vehicle = value;
      equipRef.current.name = keyName
    } else {
      equipRef.current = { vehicle: value, name: keyName  };
    }
    // Update parent state using functional update
    setState(prev => ({
      ...prev,
      equipment: {
        ...prev.equipment,
        vehicle: value,
        name: keyName
      }
    }));
  };

  // Handle selection of equipment
  const handleEquipmentSelect = (event, value) => {
    const keyName = `Key for ${formattedItem('equipment', value)}`
    
    if (inputRef.current) {
      inputRef.current.selectedEquipment = value;
    }
    if (equipRef && equipRef.current) {
      equipRef.current.selectedEquipment = value;
      equipRef.current.name = keyName
    } else {
      equipRef.current = { selectedEquipment: value, name: keyName  };
    }
    setState(prev => ({
      ...prev,
      equipment: {
        ...prev.equipment,
        selectedEquipment: value,
        name: keyName
      }
    }));
  };

  // Handle selection of customer building/jobsite
  const handleJobSiteSelect = (event, value) => {
    const formattedAddress = `${value?.communityName ? ` ${value.communityName} - ` : ''}${value?.name || ''}${value?.address ? ` ${value.address}` : ''}`
    const keyName = `Key for ${formattedAddress}`
    if (inputRef.current) {
      inputRef.current.jobSite = value;
    }
    if (equipRef && equipRef.current) {
      equipRef.current.jobSite = value;
      equipRef.current.name = keyName
    } else {
      equipRef.current = { jobSite: value, name: keyName };
    }
    setState(prev => ({
      ...prev,
      equipment: {
        ...prev.equipment,
        jobSite: value,
        name: keyName
      }
    }));
  };

  // Handle input for company building
  const handleCompanyBuildingInput = (event) => {
    const keyName = `Key for ${event.target.value}`
    if (inputRef.current) {
      inputRef.current.companyBuilding = event.target.value;
    }
    if (equipRef && equipRef.current) {
      equipRef.current.companyBuilding = event.target.value;
      equipRef.current.name = keyName
    } else {
      equipRef.current = { companyBuilding: event.target.value, name: keyName  };
    }
    setState(prev => ({
      ...prev,
      equipment: {
        ...prev.equipment,
        companyBuilding: event.target.value,
        name: keyName
      }
    }));
  };

  // Handle input for "other" details
  const handleOtherInput = (event) => {
    if (inputRef.current) {
      inputRef.current.otherDetails = event.target.value;
    }
    if (equipRef && equipRef.current) {
      equipRef.current.otherDetails = event.target.value;
    } else {
      equipRef.current = { otherDetails: event.target.value };
    }
    setState(prev => ({
      ...prev,
      equipment: {
        ...prev.equipment,
        otherDetails: event.target.value
      }
    }));
  };

  // Handle blur events to ensure data is properly updated
  const handleBlur = () => {
    if (inputRef.current) {
      // This is where you would communicate with a parent component
      // if needed through a callback prop
    }
  };

  // Render different inputs based on keyType
  const renderInputsByType = () => {
    switch (state.keyType) {
      case 'Vehicle':
        return (
          <Autocomplete
            id="vehicle-select"
            options={props?.equipment?.filter(item => item?.type === 'Vehicle') || []}
            getOptionLabel={(option) => formattedItem('vehicle', option)}
            value={state.equipment?.vehicle || null}
            onChange={handleVehicleSelect}
            onBlur={handleBlur}
            renderInput={(params) => <TextField {...params} label="Select Vehicle" variant="outlined" />}
          />
        );
      
      case 'Equipment':
        return (
          <Autocomplete
            id="equipment-select"
            options={props?.equipment?.filter(item => item?.type !== 'Vehicle') || []}
            getOptionLabel={(option) => formattedItem('equipment', option)}
            value={state.equipment?.selectedEquipment || null}
            onChange={handleEquipmentSelect}
            onBlur={handleBlur}
            renderInput={(params) => <TextField {...params} label="Select Equipment" variant="outlined" />}
          />
        );
      
      case 'Customer Building':
        return (
          <Autocomplete
            id="jobsite-select"
            options={props?.jobSites || []}
            getOptionLabel={(option) =>  formattedItem('jobSite', option)}
            value={state.equipment?.jobSite || null}
            onChange={handleJobSiteSelect}
            onBlur={handleBlur}
            renderInput={(params) => <TextField {...params} label="Select Customer Building" variant="outlined" />}
          />
        );
      
      case 'Company Building':
        return (
          <TextField
            id="company-building"
            label="Company Building"
            variant="outlined"
            fullWidth
            value={state.equipment?.keyDetails || ''}
            onChange={handleCompanyBuildingInput}
            onBlur={handleBlur}
          />
        );
      
      case 'Other':
        return (
          <TextField
            id="other-details"
            label="Other Details"
            variant="outlined"
            multiline
            rows={3}
            fullWidth
            value={state.equipment?.keyDetails || ''}
            onChange={handleOtherInput}
            onBlur={handleBlur}
          />
        );
      
      default:
        return null;
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {renderInputsByType()}
      </Grid>
    </Grid>
  );
};

export default KeyInputs;